"use strict";

exports.__esModule = true;
exports.EditableDeviceTableElement = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _DeviceContext = require("../../Device/DeviceContext");
var _DeviceListContext = require("../../Device/DeviceListContext");
var _common = require("../../ConfigurableLayout/common");
var _Core = require("../../Core");
var _EditableDeviceTableHeaderCell = require("./EditableDeviceTableHeaderCell");
var _EditableDeviceTableCell = require("./EditableDeviceTableCell");
var _ConfigurableLayout = require("../../ConfigurableLayout");
var _Utils = require("../../../Utils");
var _MetricValueBatchProvider = require("../MetricValue/MetricValueBatchProvider");
var _dec, _dec2, _class, _EditableDeviceTableElement;
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var shouldUpdate = (0, _Utils.createShouldUpdate)("width", "height", "itemHeight", "rowGutter", "children", "elementEditor");
var HeaderRow = _styledComponents["default"].div.withConfig({
  displayName: "EditableDeviceTableElement__HeaderRow",
  componentId: "sc-mggs8i-0"
})(["display:flex;border-bottom:solid 2px rgba(0,0,0,0.1);"]);
var TableBody = _styledComponents["default"].div.withConfig({
  displayName: "EditableDeviceTableElement__TableBody",
  componentId: "sc-mggs8i-1"
})(["overflow-y:hidden;"]);
var ItemRow = _styledComponents["default"].div.withConfig({
  displayName: "EditableDeviceTableElement__ItemRow",
  componentId: "sc-mggs8i-2"
})(["display:flex;border-top:solid 1px rgba(0,0,0,0.1);border-bottom:solid 1px rgba(0,0,0,0.1);"]);

/**
 * Displays a virtualized table of devices, repeating the supplied
 * element children for each device.
 */
var EditableDeviceTableElement = exports.EditableDeviceTableElement = (_dec = _DeviceListContext.DeviceListContext.withContext, _dec2 = _ConfigurableLayout.ElementEditorContext.withContext, (0, _styledComponents.withTheme)(_class = _dec(_class = _dec2(_class = (_EditableDeviceTableElement = /*#__PURE__*/function (_Component) {
  function EditableDeviceTableElement() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.renderItem = function (_ref) {
      var index = _ref.index,
        style = _ref.style;
      var _this$props = _this.props,
        height = _this$props.itemHeight,
        devices = _this$props.devices,
        children = _this$props.children,
        render = _this$props.render,
        path = _this$props.path,
        elementEditor = _this$props.elementEditor;
      var device = devices[index];
      var columnWidths = _this.getColumnWidths();
      var body = [];
      for (var i = 0; i < children.length; i++) {
        var child = children[i];
        var width = columnWidths[i];
        body.push(/*#__PURE__*/_react["default"].createElement(_EditableDeviceTableCell.EditableDeviceTableCell, {
          key: String(i),
          elementEditor: elementEditor,
          width: width,
          height: height,
          path: path.concat("children", i)
        }, render({
          type: child.type,
          props: Object.assign({}, child.props, {
            x: 0,
            y: 0,
            width: width,
            height: height
          }),
          children: child.children
        }, i)));
      }
      return /*#__PURE__*/_react["default"].createElement(ItemRow, {
        key: device.uuid,
        style: style
      }, /*#__PURE__*/_react["default"].createElement(_DeviceContext.DeviceContext.Provider, {
        value: device
      }, body));
    };
    return _this;
  }
  _inheritsLoose(EditableDeviceTableElement, _Component);
  var _proto = EditableDeviceTableElement.prototype;
  _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
    return shouldUpdate(this.props, nextProps);
  };
  _proto.getColumnWidths = function getColumnWidths() {
    var _this$props2 = this.props,
      width = _this$props2.width,
      children = _this$props2.children;
    var totalFlex = 0;
    for (var i = 0; i < children.length; i++) {
      var child = children[i];
      totalFlex += getFlexValue(child);
    }
    var availableWidth = Math.floor(width - (children.length - 1));
    var flexWidth = availableWidth / totalFlex;
    return children.map(function (child) {
      return flexWidth * getFlexValue(child);
    });
  };
  _proto.render = function render() {
    var _this$props3 = this.props,
      width = _this$props3.width,
      height = _this$props3.height,
      devices = _this$props3.devices,
      itemHeight = _this$props3.itemHeight,
      rowGutter = _this$props3.rowGutter,
      children = _this$props3.children,
      backgroundColorSource = _this$props3.backgroundColorSource;
    var availableHeight = height - itemHeight;
    var totalVisible = Math.min(devices == null ? void 0 : devices.length, Math.ceil(availableHeight / (itemHeight + rowGutter)));
    var visible = [];
    var top = 0;
    for (var index = 0; index < totalVisible; index++) {
      var style = {
        top: top,
        left: 0,
        width: width,
        height: itemHeight,
        marginTop: rowGutter || -1
      };
      visible.push(this.renderItem({
        index: index,
        style: style
      }));
      top += itemHeight + rowGutter;
    }
    return /*#__PURE__*/_react["default"].createElement(_MetricValueBatchProvider.MetricValueBatchProvider, {
      devices: devices,
      visibleDevices: (devices || []).slice(0, totalVisible),
      elements: children,
      backgroundColorSource: backgroundColorSource
    }, /*#__PURE__*/_react["default"].createElement(HeaderRow, {
      style: {
        height: itemHeight
      }
    }, this.renderHeaders()), /*#__PURE__*/_react["default"].createElement(TableBody, {
      style: {
        width: width,
        height: availableHeight
      }
    }, visible));
  };
  _proto.renderHeaders = function renderHeaders() {
    var _this$props4 = this.props,
      height = _this$props4.itemHeight,
      children = _this$props4.children,
      path = _this$props4.path,
      elementEditor = _this$props4.elementEditor;
    var columnWidths = this.getColumnWidths();
    return children.map(function (child, index) {
      var width = columnWidths[index];
      var widget = (0, _common.getWidget)(elementEditor.widgets, child.type);
      if (!widget || !widget.components.Header) {
        return /*#__PURE__*/_react["default"].createElement(_EditableDeviceTableHeaderCell.EditableDeviceTableHeaderCell, {
          key: String(index),
          width: width,
          height: height,
          element: child,
          elementEditor: elementEditor,
          path: path.concat("children", index)
        }, /*#__PURE__*/_react["default"].createElement(_Core.Heading, {
          level: 4,
          ellipsize: true
        }, child.type));
      }
      var Header = widget.components.Header;
      return /*#__PURE__*/_react["default"].createElement(_EditableDeviceTableHeaderCell.EditableDeviceTableHeaderCell, {
        key: String(index),
        width: width,
        height: height,
        element: child,
        elementEditor: elementEditor,
        path: path.concat("children", index)
      }, /*#__PURE__*/_react["default"].createElement(Header, _extends({}, child.props, {
        width: width,
        height: height
      })));
    });
  };
  return EditableDeviceTableElement;
}(_react.Component), _EditableDeviceTableElement.defaultProps = {
  rowGutter: 0,
  itemHeight: 64,
  width: 1024,
  height: 768
}, _EditableDeviceTableElement)) || _class) || _class) || _class);
function getFlexValue(input) {
  if (typeof input.props.flex === "number") {
    return input.props.flex || 1;
  } else if (input.props.element != null && input.props.element.props != null) {
    return input.props.element.props.flex || 1;
  }
  return 1;
}